import script from "./FranchiseSyncIssuesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseSyncIssuesPanel.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseSyncIssuesPanel.vue?vue&type=style&index=0&id=dc0c3524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc0c3524"]])

export default __exports__